// Browsers refuse to copy out of a type="password" input and leave the previous
// clipboard content in place (e.g. the email). Write the selected text ourselves.
export function copyPasswordSelection(event) {
  const el = event.target;
  if (!el || typeof el.selectionStart !== 'number' || !event.clipboardData) return;
  const text = el.value.substring(el.selectionStart, el.selectionEnd);
  if (!text) return;
  event.clipboardData.setData('text/plain', text);
  event.preventDefault();
}
